module.exports = __webpack_public_path__ + "static/banner-image-f484cdc38917c4366d72cfe6e2b2d64d.png";